import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "./IncidentReportingModal.css";

const IncidentReportingModal = ({
  isOpen,
  toggle,
  children,
  title = "",
  size = "xl",
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      fade={false}
      backdrop={"static"}
      className=""
      centered
      size={size}
      scrollable
    >
      <ModalHeader className="border-0" toggle={toggle}>
        {title}
      </ModalHeader>
      <ModalBody>{children}</ModalBody>
    </Modal>
  );
};

export default IncidentReportingModal;
